<header class="timeapp">
  <mat-icon svgIcon="ss-logo" class="logo-img"></mat-icon>
	<div *ngIf="showDate" class="container date-display-container">
      <p class="date-text">{{ chosenDate }}</p>
    </div>
  <div *ngIf="lockIcon" class="lock-icon-wrapper mat-basic container">
    <img class="lock-icon" [src]="lockIcon" alt="lock"/>
  </div>
  <mat-icon
    class="material-icons icon_color"
    matTooltip="{{ 'MAIN_APP_DASHBOARD.einstellungen' | translate }}"
    [matMenuTriggerFor]="menu"
    >menu
  </mat-icon>
  <mat-menu #menu="matMenu" class="shadow">
    <button mat-menu-item routerLink="/timeapp/settings" *ngIf="showTimeApp">{{ 'MAIN_APP_DASHBOARD.einstellungen' | translate }}</button>
    <button mat-menu-item routerLink="/dashboard" *ngIf="showVinavon">{{ "MAIN_APP_DASHBOARD.dashboard" | translate }}</button>
    <button mat-menu-item routerLink="/serviceapp/saagenda" *ngIf="showServiceApp">{{ "MAIN_APP_SERVICE_APP.serviceApp" | translate }}</button>
    <button mat-menu-item routerLink="/timeapp/scan" *ngIf="showTimeApp">{{ "MAIN_APP_DASHBOARD.scanner" | translate }}</button>
    <button mat-menu-item (click)="logout()">{{ "MAIN_APP_DASHBOARD.abmelden" | translate }}</button>
  </mat-menu>
</header>

